import React from 'react';

export const IconPlayWhite = () => {
  return (
    <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.71953 1.42676C1.2501 1.15976 0.666016 1.49713 0.666016 2.03529V8.96483C0.666016 9.50298 1.2501 9.84034 1.71953 9.5733L7.81121 6.10853C8.28428 5.83951 8.28428 5.1606 7.81121 4.89158L1.71953 1.42676Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
